<template>
  <AlbumLegacySyncDialog
      :dialog-visible="true"
      :school-list="schoolList"
      @close="closePage"
  />
</template>

<script>
import SystemConfigService from "@/services/AdminService/SystemConfigService";
import AlbumLegacySyncDialog from "@/modules/album/AlbumLegacySyncDialog.vue";

export default {
  name: "AlbumLegacySync",
  components: {AlbumLegacySyncDialog},
  data() {
    return {schoolList: []};
  },
  async created() {
    if (this.$store.state.auth.user.appType !== "supperSys") {
      this.$message.error("Chỉ Super Admin được phép đồng bộ album cũ");
      this.$router.replace("/master/other/manage-data-system");
      return;
    }
    try {
      const response = await SystemConfigService.findSchoolConfig("", "", true);
      this.schoolList = response.data.data || [];
    } catch (error) {
      this.$message.error("Không tải được danh sách trường");
    }
  },
  methods: {
    closePage() {
      this.$router.push("/master/other/manage-data-system");
    },
  },
};
</script>
